module.exports = __webpack_public_path__ + "img/microchip.67f381ba.svg";